module.exports = __webpack_public_path__ + "ce4819187021678149c6640ddfd8e430.png";